<template>
  <div class="sky-date-picker">
    <sky-suffix v-bind="$attrs">
      <el-date-picker
        v-model="timeValue"
        :type="type"
        :value="selfData"
        @change="change"
        v-bind="$attrs"
        :key="datePickerKey"
        :value-format="valueFormat"
        :unlink-panels="true"
        :placeholder="placeholder"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
    </sky-suffix>
  </div>
</template>
<script>
import SkySuffix from "../formComponents/SkySuffix.vue";
import formStore from "@/mixins/formStore.js";
export default {
  name: "sky-date-picker",
  props: {
    value: [String, Number, Array, Object],
    placeholder: [String, Number],
    pickerOptions: {
      type: Object
    },
    valueFormat: {
      default: "yyyy-MM-dd"
    },
    type: {
      default: "date"
    },
    datePickerKey: {
      default: "daterange"
    }
  },
  mixins: [formStore],
  inheritAttrs: false,
  components: {
    SkySuffix
  },
  data() {
    return {
      timeValue: ""
    };
  },
  methods: {
    setVal() {
      this.$emit("input", this.timeValue);
    },
    getVal() {
      this.timeValue = this.value;
    },
    change(val) {
      this.timeValue = val;
      !this.delay && this.$emit("input", val);
      this.$emit("change", val);
    }
  },
  watch: {
    value: {
      handler: function(val, oldVal) {
        if (val) {
          this.timeValue = val;
        } else {
          this.timeValue = "";
        }
      },
      immediate: true
    }
  },
  computed: {},
  created() {}
};
</script>
<style scoped lang="scss">
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
</style>
